// extracted by mini-css-extract-plugin
export default {"pagination":"ProjectShowGrid_pagination__muzWV"};